module.exports = __webpack_public_path__ + "img/service-event-forms.cb2e08e4.png";